import React from "react";

export default function Title() {
return <h1>Scoreboard</h1>
} 